import Loader from '@src/components/loader';
import AddToCartSelector from '@src/components/product/AddToCartSelector';
import ProviderDetails from '@src/components/product/ProviderDetails';
import getCartItemServiceLabel from '@src/functions/getCartItemServiceLabel';
import { getProductServicesArray } from '@src/functions/getProductServicesArray';
import { setSelectedProvider, updateSelectedProvider } from '@src/redux/actions';
import axios from 'axios';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const formatCurrency = require('format-currency');

const CartContent = ({
	item,
	incrementQty,
	decrementQty,
	removeFromCart,
	provider,
	setSelectedProvider,
	updateSelectedProvider,
	externalrequest,
	reviews,
	onQuantityChange,
}) => {
	const [forceStateLocal, setForceStateLocal] = useState(false);
	const [providerDetails, setProviderDetails] = useState({});
	const [showProviderDetails, setShowProviderDetails] = useState(false);
	const [isQuantityLoading, setIsQuantityLoading] = useState(false);

	var service = getCartItemServiceLabel(item);

	useEffect(() => {
		const lat = item.selectedProviderService.providerId.Latitude;
		const lng = item.selectedProviderService.providerId.Longitude;
		const ProviderId = item.selectedProviderService.providerId.ProviderId;

		if (lat != undefined && lng != undefined) {
			// TODO: put in Env Constants
			let url = `https://api.marketring-api.com/v1/providerlocations/${ProviderId}?GoogleData=true&lat=${lat}&lng=${lng}`;

			const fetchData = async () => {
				const result = await axios
					.get(url, { crossdomain: true })
					.then(response => {
						return response;
					})
					.catch(error => {
						return null;
					});
				if (result) {
					setProviderDetails(result.data);
				}
			};
			fetchData();
		}
	}, []);

	useEffect(() => {
		onQuantityChange(false);
		setIsQuantityLoading(false);
	}, [item]);

	var { serviceArray, selectedServiceIndex, optionalServiceArray } = getProductServicesArray(
		item,
		0,
		provider,
		externalrequest
	);

	const onQuantityIncrement = item => {
		incrementQty(item, 1);
		onQuantityChange(true);
		setIsQuantityLoading(true);
	};

	const onQuantityDecrement = id => {
		decrementQty(id);
		onQuantityChange(true);
		setIsQuantityLoading(true);
	};

	if (!item.urlSlug) {
		// FIXME: Used for Phantom add to Cart Components
		return '';
	}
	return (
		<div className="cart-item-new">
			{isQuantityLoading && (
				<div className="overlay overlay-loading">
					<div className="overlay-inner">
						<Loader />
						<p>Updating the information...</p>
					</div>
				</div>
			)}

			<div className={`content-container ${isQuantityLoading ? 'loading' : ''}`}>
				<div className="upper">
					<div className="image-container">
						<div style={{ width: 50, height: 50, position: 'relative' }}>
							<Image
								objectFit="contain"
								layout="fill"
								src={
									item?.productPictures.length >= 1
										? item?.productPictures[0].imageUrl
										: require('../../../static/images/dummy.png')
								}
								alt=""
							/>
						</div>
					</div>
					<div className="title">
						<Link
							href={item.returnUrl ? item.returnUrl : `/product?productid=${item.urlSlug}`}
							as={item.returnUrl ? item.returnUrl : `/product/${item.urlSlug}`}>
							<a>
								<h2>{item.application ? item.name + ' for ' + item.applicationLabel : item.name}</h2>
							</a>
						</Link>

						<small>{item.shortDescription}</small>
					</div>

					<div className="central-part">
						<div className="price">
							<h2>${formatCurrency(item.price)}</h2>
						</div>

						<div className="quantity">
							<button
								className="btn"
								onClick={() => onQuantityDecrement(item.id)}
								data-type="minus"
								data-field="">
								<i className="fas fa-minus-square"></i>
							</button>

							<input
								type="text"
								name="quantity"
								value={item.qty}
								readOnly={true}
								className="form-control"
							/>

							<button className="btn" onClick={() => onQuantityIncrement(item)} data-type="plus">
								<i className="fas fa-plus-square"></i>
							</button>
						</div>

						<div className="total-price">
							<h2>${formatCurrency(item.sum)}</h2>
						</div>
					</div>
				</div>

				<div className="mt-2">
					<AddToCartSelector
						isCart
						compact
						optionalServiceArray={optionalServiceArray}
						serviceArray={serviceArray}
						selectedServiceIndex={selectedServiceIndex}
						item={item}
						setSelectedProvider={setSelectedProvider}
						dontShowBuyButton={true}
						provider={provider}
						reviews={reviews}
						showProviderDetails={() => setShowProviderDetails(!showProviderDetails)}
						forceState={() => {
							setForceStateLocal(!forceStateLocal);
						}}
						updateSelectedProvider={updateSelectedProvider}
					/>
				</div>

				{showProviderDetails && (
					<ProviderDetails
						horizontal
						optionalServiceArray={optionalServiceArray}
						show={showProviderDetails}
						data={providerDetails}
						close={() => setShowProviderDetails(false)}
						reviews={reviews}
					/>
				)}

				<div className="remove">
					<button
						className="btn remove"
						onClick={() => {
							setIsQuantityLoading(true);
							removeFromCart(item);
						}}>
						Remove
					</button>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({ provider, roadside }) => ({
	provider,
	roadside,
});

export default connect(mapStateToProps, { setSelectedProvider, updateSelectedProvider })(CartContent);
